module.exports = __webpack_public_path__ + "img/linux.cfb6820c.png";